import { formatMoney } from "#common/Funciones"
import MainDetailsBody from "#core/components/main-details/MainDetailsBody"
import { useVacanteRedux } from "#vacancy/redux/slice"

export default function VacancyDetailsSalary() {
	const { vacancy } = useVacanteRedux()
	const { currency } = vacancy || {}
	const fields = [
		{
			label: "Sueldo mensual",
			value: formatMoney(vacancy?.sueldo_mensual, currency),
			size: 4,
		},
		{
			label: "Bono trimestral",
			value: vacancy?.bono_trimestral
				? "N/A"
				: formatMoney(vacancy?.bono_trimestral, currency),
		},
		{
			label: "Garantía",
			value: vacancy?.garantia ? "N/A" : formatMoney(vacancy?.garantia, currency),
		},
		{
			label: "Duración",
			value: vacancy?.duracion,
			size: 2,
		},
	]

	return <MainDetailsBody ItemsWrapper={fields} />
}
